<nz-label nz-checkbox [(ngModel)]="checked" class="checkbox-disable" nzNoColon></nz-label>
<nz-form-label [attr.nzFor]="formFieldInfo.fieldCode">
    <span>{{name}} <span *ngIf="formFieldInfo.isRequired" style="color:red;">(*)</span></span>
    <app-component-tooltip [formFieldInfo]="fieldDataInfo"></app-component-tooltip>
</nz-form-label>
<nz-form-control nzValidateStatus="error">
    <nz-date-picker style="width:100%" [attr.id]="formFieldInfo.fieldCode" [(ngModel)]="value" [disabled]="!checked" nzPlaceHolder="Định dạng nhập yyyy-MM-dd"
        nzSize="large" nzFormat="yyyy-MM-dd" (change)="onChangeDateCheckBox()" (ngModelChange)="modelChange()">
    </nz-date-picker>
</nz-form-control>